import { Tab } from '@mui/material'
import styled from 'styled-components'
import { FONTS, SPACING, TYPOGRAPHY } from 'utils'

interface ITab {
  backgroundColor?: string
  boxShadow?: string
  colorText?: string
}
export const TabCustom = styled(Tab)<ITab>`
  margin-top: ${SPACING.spacing20};
  margin-left: ${SPACING.spacing20};
  font-size: ${TYPOGRAPHY.bodySize16};
  font-weight: ${FONTS.bold};
  border-radius: 2px 2px 0px 0px;
  box-shadow: none;
  background: ${({ backgroundColor }) => backgroundColor};
`
